import React from "react";
import { ActividadCard } from "../actividades/ActividadCard";
import { contarAsistentes } from "./eventosUtils";

export const EventoActividadCard = ({ evento, opTrabajadores, onChange }) => (
	<div className="events-card-frame events-type-activity">
		<ActividadCard
			data={evento}
			totalAsistentes={contarAsistentes(evento)}
			opTrabajadores={opTrabajadores}
			setSuccesCrearComida={onChange}
		/>
	</div>
);
